import { render, staticRenderFns } from "./OnLineSalesTable.vue?vue&type=template&id=2034864c"
import script from "./OnLineSalesTable.vue?vue&type=script&lang=js"
export * from "./OnLineSalesTable.vue?vue&type=script&lang=js"
import style0 from "./OnLineSalesTable.vue?vue&type=style&index=0&id=2034864c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports